import React from "react";
import { type IFiltroEquiposVistaProps } from "../interfaces";
import {
    TextInput,
    Grid,
    Box,
    Text,
    Button,
    Select,
} from "@mantine/core";
import { IconClearAll, IconSearch } from "@tabler/icons-react";

const FiltroEquiposVista: React.FunctionComponent<IFiltroEquiposVistaProps> = ({
    consultarEquipos,
    filtro,
    manejarCambioFiltroEquipo,
    entidadesEquipo,
    limpiarFiltros,
}) => {
    return (
        <Box pl="md" pr="md" pb="sm" pt="sm">
            <Grid gutter="sm">
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <TextInput
                        placeholder="Código Equipo"
                        name="CodigoEquipo"
                        size="xs"
                        maxLength={50}
                        value={filtro.Codigo || ""}
                        onChange={(event) => {
                            manejarCambioFiltroEquipo("Codigo", event.currentTarget.value)
                        }}
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        placeholder="Tipo de Equipo"
                        clearable
                        size="xs"
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.TiposEquipo.map(tipo => ({
                            value: tipo.Id.toString(),
                            label: tipo.Nombre
                        }))}
                        value={filtro.TipoEquipoId?.toString() || null}
                        onChange={(value) => {
                            manejarCambioFiltroEquipo("TipoEquipoId", value ? parseInt(value) : undefined)
                        }}
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        placeholder="Estado"
                        clearable
                        size="xs"
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.EstadosEquipo.map(estado => ({
                            value: estado.Id.toString(),
                            label: estado.Nombre
                        }))}
                        value={filtro.EstadoEquipoId?.toString() || null}
                        onChange={(value) => {
                            manejarCambioFiltroEquipo("EstadoEquipoId", value ? parseInt(value) : undefined)
                        }}
                    />
                </Grid.Col>
                
                <Grid.Col
                    span={{ base: 12, md: 3 }}
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                    }}
                >
                    <Button
                        onClick={limpiarFiltros}
                        color="primary"
                        variant="light"
                        size="compact-sm"
                        radius="lg"
                        rightSection={<IconClearAll opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Limpiar</Text>
                    </Button>

                    <Button
                        onClick={() => consultarEquipos(filtro)}
                        color="primary"
                        variant="filled"
                        size="compact-sm"
                        radius="lg"
                        rightSection={<IconSearch opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Consultar</Text>
                    </Button>
                </Grid.Col>
            </Grid>
        </Box>
    );
}

export default FiltroEquiposVista;